var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pageSection)?_c('v-card',{attrs:{"outlined":""}},[_c(_setup.CardTitle,{attrs:{"small":"","icon":_vm.icon,"title":_vm.title,"iconColor":_vm.iconColor}}),_c('v-divider'),_c('v-card-text',[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }